import axios, { AxiosRequestTransformer } from "axios";
import { handleRequestDates, handleResponseDates } from "../helpers/DateHelper";

const devApi = process.env.REACT_APP_DEV_API_URL;
const localApi = process.env.REACT_APP_LOCAL_API_URL;

const devNotificationHubUrl = `${process.env.REACT_APP_DEV_NOTIFICATION_HUB_URL}`;
const localNotificationHubUrl = `${process.env.REACT_APP_LOCAL_NOTIFICATION_HUB_URL}`;

export const currentApi = devApi;
export const currentNotificationHub = devNotificationHubUrl;

export const axiosApi = axios.create({
  baseURL: currentApi,
});

axiosApi.interceptors.request.use((config) => {
  if (!config.data) return config;
  handleRequestDates(config.data);
  return config;
});

export const ERP_dateTimeFormat = "dd/MM/yyyy HH:mm:ss";
export const ERP_reportsDateTimeFormat = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";

export const defaultAccountingAmountFormat = {
  type: "fixedPoint",
  precision: 2,
};
export const defaultAccountingQuantityFormat = {
  type: "fixedPoint",
  precision: 3,
};
